import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Combobox, IconButton } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components/foundations";

const PAGINATION_HEIGHT = 55;
const TABLE_TOP_HEIGHT = 150;
const PAGINATION_OFFSET = 100;

export const TableWrapper = styled(Box)<{
    hasPagination: boolean;
    hasData: boolean;
}>`
    & [data-automation="table-top-title-container"] {
        padding: 11px 24px;
    }

    .table-container {
        height: calc(
            100% -
                ${({ hasPagination }) => TABLE_TOP_HEIGHT + (hasPagination ? PAGINATION_OFFSET : PAGINATION_HEIGHT)}px
        );
    }

    & :has(.ant-table-body):not(.table-container),
    .ant-table-body {
        height: 100%;
    }

    & .ant-table-body {
        overflow: hidden auto !important;

        ${({ hasData }) =>
            !hasData &&
            `
            & .ant-table-cell {
                border: none;
            }
        `};
    }

    & .ant-table-pagination.ant-pagination {
        margin-top: 32px;
    }

    & col.ant-table-selection-col {
        width: 24px !important;
        min-width: 24px !important;
    }
`;

export const TopicsDropdownWrapper = styled(Box)`
    & .DropdownButton--filtersBarDropdownButton {
        border: none;
        height: unset;
        background-color: unset;
        box-shadow: unset;
        padding: 0;
    }
`;

export const TopicOptionLabel = styled(Combobox.OptionLabel)`
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const CSVUploadButton = styled(IconButton)`
    /* stylelint-disable-next-line selector-id-pattern -- "Shape" is the literal, case-sensitive id baked into the SVG icon markup */
    & svg #Shape {
        fill: ${colorsPalettes.blue[400]};
    }
`;
